import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ConversationModuleState } from 'src/core/states/conversation/conversation-module.state';
import { GenericLookupTypeState } from 'src/core/states/generic-lookup-type/generic-lookup-type.state';
import { map } from 'rxjs/operators';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { ConversationMixedListViewOption } from 'src/core/models/generic-lookup-type/conversation/conversation-mixed-list-view-option.glt';
import { ConversationService } from 'src/core/services/conversation/conversation.service';
import { CompactPlayerComponent } from 'src/ca-shared/player/compact-player/compact-player.component';

@Component({
    selector: 'ca-conversation-mixed-list',
    templateUrl: './conversation-mixed-list.component.html',
    styleUrls: ['./conversation-mixed-list.component.scss'],
    standalone: false
})
export class ConversationMixedListComponent implements OnInit {
  @Select(ConversationModuleState.getActiveList)
  activeList$: Observable<number>;

  @Select(ConversationModuleState.getActiveView)
  activeView$: Observable<number>;

  viewOptions$: Observable<GenericLookupDto[]>;
  viewOptions: GenericLookupDto[] = [];

  @Input()
  compactPlayer: CompactPlayerComponent;

  standardListVisible = true;
  cardListVisible = false;

  @Output()
  conversationIdChange: EventEmitter<{
    id: number;
  }> = new EventEmitter();

  @Output()
  dataLoaded = new EventEmitter();

  constructor(private store: Store, private conversationService: ConversationService) {}

  ngOnInit() {
    this.viewOptions$ = this.store
      .select(GenericLookupTypeState.getGenericLookups)
      .pipe(map(filterFn => filterFn(ConversationMixedListViewOption)));

    this.viewOptions$.subscribe(genericLookups => {
      this.viewOptions = genericLookups;
    });

    this.activeView$.subscribe(activeView => {
      this.standardListVisible = activeView === ConversationMixedListViewOption.standard;
      this.cardListVisible = activeView === ConversationMixedListViewOption.card;
    });
  }

  onConversationIdChanged(conversationId) {
    this.conversationIdChange.emit(conversationId);
  }

  onDataLoaded() {
    this.dataLoaded.emit();
  }
}
